"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFitPayBankAccountDummy = exports.StripePayment = void 0;
var contract_const_1 = require("@src/const/contract.const");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var module_mapping_1 = require("@src/const/module.mapping");
var notes_helper_const_1 = require("@src/const/notes-helper.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var stripe_js_1 = require("@stripe/stripe-js");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var helper_const_1 = require("../../const/helper.const");
var input_output_helper_const_1 = require("../../const/input-output-helper.const");
var input_mapping_const_1 = require("../../const/input.mapping.const");
var object_service_1 = require("../../services/object-service");
var settings_service_1 = require("../../services/settings.service");
var fitpay_api_1 = require("./services/fitpay-api");
var voucher_code_const_1 = require("../fitfms/membership-completion/voucher-code.const");
var backend_services_1 = require("@src/services/backend-services");
var validate_const_1 = require("../fitfms/membership-completion/const/validate.const");
var payment_switcher_1 = require("./payment-switcher");
var fitpay_bank_account_helper_1 = require("./fitpay-bank-account.helper");
Object.defineProperty(exports, "setFitPayBankAccountDummy", { enumerable: true, get: function () { return fitpay_bank_account_helper_1.setFitPayBankAccountDummy; } });
var payment_link_helper_1 = require("./payment-link.helper");
var StripePayment = /** @class */ (function () {
    function StripePayment() {
        var _a, _b;
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.fitpayApi = object_service_1.ObjectService.getInstance(fitpay_api_1.FitpayApi);
        this.magiclinePaymentChoice = 'STRIPE';
        this.hideTabs = (_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.customTabs;
        this.externalPaymentProviderCallback = function () { };
        this.loadingFinishedCallback = function () { };
        this.disableFitpay = function () { };
        this.handledReturningPaymentCallback = function () { };
        this.stripeKey = '';
        this.fitpayEnabled = false;
        this.ongoingPaymentButMissingCustomerDetails = false; // express only
        this.returnFromPaymentButMissingCustomerDetails = false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    StripePayment.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedPaymentMethod, queryParams, intentRes, studioId, accountId, _a, returningFromPayment, user, captureRes;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            return __generator(this, function (_p) {
                switch (_p.label) {
                    case 0:
                        if (this.config.get.environment === 'dev') {
                            console.error('You use default stripe component without custom tabs if you want to add them please add customTabs in your stripe settings object');
                        }
                        selectedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
                        if (!selectedPaymentMethod) {
                            localStorage.setItem('selectedPaymentMethod', 'card');
                        }
                        // Check if fitpay is disabled
                        if (!((_b = this.config.get.finish) === null || _b === void 0 ? void 0 : _b.stripe)) {
                            this.magiclinePaymentChoice = 'DIRECT_DEBIT';
                            console.log('Stripe is not activated in settings object, disabling fitBuy');
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'disableFitpay',
                            });
                            return [2 /*return*/];
                        }
                        else if (((_c = this.config.get.finish) === null || _c === void 0 ? void 0 : _c.stripe) === true) {
                            this.fitpayEnabled = true;
                        }
                        queryParams = (0, payment_link_helper_1.readFitpayLinkQueryParams)(window.location.search);
                        if (!(queryParams.geburtstag && queryParams.email)) return [3 /*break*/, 2];
                        this.missingPaymentDetails = {
                            birthday: queryParams.geburtstag,
                            email: queryParams.email,
                        };
                        return [4 /*yield*/, this.fitpayApi.createMissingPaymentIntent(this.config.get, this.missingPaymentDetails)];
                    case 1:
                        intentRes = _p.sent();
                        if ('error' in intentRes) {
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'disableFitpay',
                                value: intentRes.error,
                            });
                            this.fitpayEnabled = false;
                            return [2 /*return*/];
                        }
                        else {
                            this.paymentIntent = intentRes;
                            // klarna requires studio id, as its otherwise lost after redirect
                            localStorage.setItem(input_mapping_const_1._AllMappings.studioId.uid, (_e = (_d = this.paymentIntent) === null || _d === void 0 ? void 0 : _d.customer) === null || _e === void 0 ? void 0 : _e.studioId);
                        }
                        _p.label = 2;
                    case 2:
                        studioId = this.missingPaymentDetails ? (_f = this.paymentIntent.customer) === null || _f === void 0 ? void 0 : _f.studioId : (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        accountId = (_j = (_h = (_g = this.config.get) === null || _g === void 0 ? void 0 : _g.stripe) === null || _h === void 0 ? void 0 : _h.stripeStudioMapping) === null || _j === void 0 ? void 0 : _j[studioId];
                        if (!accountId) {
                            console.error('No stipe key found for studio', studioId, 'in stripe settings!');
                            this.magiclinePaymentChoice = 'DIRECT_DEBIT';
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'disableFitpay',
                            });
                            return [2 /*return*/];
                        }
                        // stripe keys
                        if ((_l = (_k = this.config.get) === null || _k === void 0 ? void 0 : _k.stripe) === null || _l === void 0 ? void 0 : _l.forceDevKey) {
                            this.stripeKey =
                                'pk_test_51QcncMRx0TziwLg9AUcsH57dOa5ifvKffUxEhEUCwrtdNHFd8LIFPV9BYuRlCC2RBE5ETsz9zxlTi9CEaOmrjZV0008QVYrOTy';
                            console.warn(' ---------- USING STRIPE TEST MODE --------------');
                        }
                        else if (this.config.get.environment === 'prod' || ((_o = (_m = this.config.get) === null || _m === void 0 ? void 0 : _m.stripe) === null || _o === void 0 ? void 0 : _o.forceLiveKey)) {
                            this.stripeKey =
                                'pk_live_51QcncMRx0TziwLg9CaMZw1QsZIxLsXtHvEPgpejTKKJr4gpbbxJ2D42htnGse374NeWtCrMZmf4mIU7WWsUIlIBb00Xp5eHxIT';
                        }
                        else {
                            this.stripeKey =
                                'pk_test_51QcncMRx0TziwLg9AUcsH57dOa5ifvKffUxEhEUCwrtdNHFd8LIFPV9BYuRlCC2RBE5ETsz9zxlTi9CEaOmrjZV0008QVYrOTy';
                            console.warn(' ---------- USING STRIPE TEST MODE --------------');
                        }
                        _a = this;
                        return [4 /*yield*/, (0, stripe_js_1.loadStripe)(this.stripeKey, {
                                stripeAccount: accountId,
                            })];
                    case 3:
                        _a.stripe = _p.sent();
                        this.stripePaymentContainer = (0, cash_dom_1.default)("[data-ref='".concat(module_mapping_1._MembershipCompletionReferences.fitpayCheckout.uid, "']"));
                        return [4 /*yield*/, this.checkPaymentIntentStatus()];
                    case 4:
                        returningFromPayment = _p.sent();
                        console.log('returning payment?', returningFromPayment);
                        if (!(!returningFromPayment.post_payment || !returningFromPayment.payment_success)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.requestPaymentIntent()];
                    case 5:
                        _p.sent();
                        if (!this.paymentIntent) {
                            console.warn('Payment intent failed, disabling fitBuy');
                            this.magiclinePaymentChoice = 'DIRECT_DEBIT';
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'disableFitpay',
                            });
                            return [2 /*return*/];
                        }
                        _p.label = 6;
                    case 6:
                        if (!(returningFromPayment.post_payment && returningFromPayment.payment_success)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.readCustomerAndContractFromLocalstorage()];
                    case 7:
                        user = (_p.sent()).data;
                        return [4 /*yield*/, this.handleReturningPayment(returningFromPayment, user)];
                    case 8:
                        captureRes = _p.sent();
                        if (!captureRes.success) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(captureRes.message));
                            (0, generator_const_1._DeleteLoadingScreen)();
                        }
                        this.magiclinePaymentChoice = 'STRIPE'; // returning from successful payment allows finishing payment, use stripe here so iban isnt validated, will be overwritten by onload
                        this.returnFromPaymentButMissingCustomerDetails = true;
                        this.communicationService.sendEvent({
                            event: 'custom',
                            module: this,
                            name: 'handledReturningPaymentCallback',
                            value: captureRes.success,
                        });
                        return [3 /*break*/, 10];
                    case 9:
                        if (returningFromPayment.post_payment && !returningFromPayment.payment_success) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Payment failed'));
                            (0, generator_const_1._DeleteLoadingScreen)();
                        }
                        else {
                            (0, generator_const_1._DeleteLoadingScreen)();
                        }
                        _p.label = 10;
                    case 10:
                        if (this.stripePaymentContainer.length > 0) {
                            this.createStripeElements();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StripePayment.prototype.createStripeElements = function (container, paymentMethodOrder) {
        var _this = this;
        if (container === void 0) { container = this.stripePaymentContainer; }
        var form = document.createElement('form');
        var cardWrapper = document.createElement('div');
        form.appendChild(cardWrapper);
        if (this.hideTabs === true) {
            form.style.top = '-65px';
            form.style.position = 'relative';
            cardWrapper.style.overflow = 'hidden';
            var hideWrapper = document.createElement('div');
            hideWrapper.className = 'hide-wrapper';
            hideWrapper.appendChild(form);
            container.append(hideWrapper);
        }
        else {
            container.append(form);
        }
        // payment choice button
        var fitpaySwitcher = (0, cash_dom_1.default)("[data-ref='".concat(module_mapping_1._MembershipCompletionReferences.fitpayPaymentSwitcher.uid, "']"));
        if (fitpaySwitcher.length) {
            this.changePaymentMethod(fitpaySwitcher[0]);
            fitpaySwitcher.off('click');
            fitpaySwitcher.on('click', function (event) {
                if (event === null || event === void 0 ? void 0 : event.currentTarget) {
                    var payment = _this.changePaymentMethod(event.currentTarget);
                    console.log('set payment type to', payment);
                    if (payment.type !== 'magicline' && _this.hideTabs === true) {
                        _this.reshuffleStripePaymentOrder(payment);
                    }
                }
            });
        }
        else {
            console.log('No fittec payment switcher found!');
        }
        this.loadStripePaymentsModule(cardWrapper, paymentMethodOrder);
    };
    StripePayment.prototype.reshuffleStripePaymentOrder = function (payment) {
        var tab = (0, cash_dom_1.default)('.w-tab-pane[data-w-tab="' + payment.original + '"]');
        tab.html('');
        if (tab) {
            this.createStripeElements(tab, [payment.value]);
        }
    };
    StripePayment.prototype.changePaymentMethod = function (domElement) {
        var payment = (0, payment_switcher_1.determinePaymentMethod)(domElement);
        if (payment.type === 'magicline' && this.magiclinePaymentChoice === 'STRIPE') {
            (0, input_output_helper_const_1._ClearFields)(this.$container, input_mapping_const_1._BankAccountMapping);
        }
        this.magiclinePaymentChoice = payment.type !== 'magicline' ? 'STRIPE' : payment.value;
        console.log('changed payment type to', this.magiclinePaymentChoice, 'because input was', payment.type);
        if (this.returnFromPaymentButMissingCustomerDetails) {
            this.magiclinePaymentChoice = 'STRIPE';
            console.log('changed payment type to', this.magiclinePaymentChoice, 'because user returned from klarna');
        }
        return payment;
    };
    //NOTE: TO BE DONE
    StripePayment.prototype.loadStripePaymentsModule = function (formToAttach, paymentMethodOrder) {
        return __awaiter(this, void 0, void 0, function () {
            var appearance, expressCheckoutOptions, expressCheckoutContainer;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                if (this.paymentElement) {
                    this.paymentElement.unmount();
                }
                if (this.stripeExpressElements) {
                    this.stripeExpressElements.unmount();
                }
                appearance = __assign(__assign({}, (((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.appearance) || {})), { theme: ((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.stripe) === null || _d === void 0 ? void 0 : _d.theme) || 'night' });
                // we have no payment intent at the time when returning from klarna. shouldnt render a new payment element anyways
                if (!this.paymentIntent)
                    return [2 /*return*/];
                console.log('created payment intent for customer', (_e = this.paymentIntent) === null || _e === void 0 ? void 0 : _e.customerId);
                // make sure to save the customer for redirects in local storage
                localStorage.setItem(input_mapping_const_1.fitpayMappings.stripeCustomerId.uid, this.paymentIntent.customerId);
                this.clientSecret = this.paymentIntent.clientSecret;
                console.log('got stripe secret', this.clientSecret);
                this.stripeElements = this.stripe.elements({
                    clientSecret: this.clientSecret,
                    appearance: appearance,
                    locale: 'de',
                });
                console.log('stripe elements called', this.paymentIntent);
                expressCheckoutOptions = {
                    buttonType: {
                        applePay: 'buy',
                        googlePay: 'buy',
                    },
                    paymentMethods: {
                        googlePay: 'always',
                        applePay: 'always',
                        amazonPay: 'auto',
                        link: 'auto',
                    },
                    paymentMethodOrder: ['apple_pay', 'google_pay', 'amazon_pay', 'link'],
                };
                this.stripeExpressElements = this.stripeElements.create('expressCheckout', expressCheckoutOptions);
                // callback for google pay, paypal, etc. after customer did external payment
                this.stripeExpressElements.on('confirm', function (event) {
                    console.log('payment confirm event!', event);
                    _this.confirmExpressCheckout(event);
                });
                this.stripeExpressElements.on('cancel', function (event) {
                    console.log('payment cancel event!', event);
                    (0, generator_const_1._DeleteLoadingScreen)();
                    (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Payment cancelled'));
                    _this.communicationService.sendEvent({
                        event: 'custom',
                        module: _this,
                        name: 'cancelPayment',
                        value: true,
                    });
                });
                this.stripeExpressElements.on('escape', function (event) {
                    console.log('payment escape event!', event);
                });
                this.stripeExpressElements.on('loaderror', function (event) {
                    console.log('payment loaderror event!', event);
                });
                this.stripeExpressElements.on('ready', function (event) {
                    console.log('payment ready event!', event);
                });
                // callback for google pay, paypal, etc before the customer can do external payment
                this.stripeExpressElements.on('click', function (event) {
                    console.log('stripe click event', event);
                    localStorage.setItem('selectedPaymentMethod', event.expressPaymentType);
                    (0, generator_const_1._CreateLoadingScreen)();
                    _this.communicationService.sendEvent({
                        event: 'custom',
                        module: _this,
                        name: 'loading',
                        value: true,
                    });
                    var options = {
                        emailRequired: true,
                        lineItems: [{ amount: 100, name: 'Test' }],
                        business: { name: 'Fitpay GmbH' },
                        //phoneNumberRequired: true,
                        billingAddressRequired: true,
                        applePay: {}, // can set recurring here
                    };
                    event.resolve(options);
                });
                expressCheckoutContainer = (0, cash_dom_1.default)("[data-ref='".concat(module_mapping_1._MembershipCompletionReferences.fitpayExpressCheckout.uid, "']"));
                console.log('express container length', expressCheckoutContainer.length);
                if (expressCheckoutContainer.length > 0) {
                    this.stripeExpressElements.mount(expressCheckoutContainer.get(0));
                }
                // this is the payments element for cards, klarna etc
                this.paymentElement = this.stripeElements.create('payment', {
                    layout: {
                        type: 'accordion',
                        defaultCollapsed: false,
                        radios: true,
                        spacedAccordionItems: false,
                    },
                    paymentMethodOrder: paymentMethodOrder || ['card', 'klarna', 'apple_pay', 'google_pay', 'amazon_pay'],
                });
                this.paymentElement.mount(formToAttach);
                this.paymentElement.on('change', function (event) {
                    var _a;
                    if ((_a = event === null || event === void 0 ? void 0 : event.value) === null || _a === void 0 ? void 0 : _a.type) {
                        localStorage.setItem('selectedPaymentMethod', event.value.type);
                        console.log('Selected payment method (standard elements):', event.value.type);
                    }
                });
                this.communicationService.sendEvent({
                    event: 'custom',
                    module: this,
                    name: 'loadingFinishedCallback',
                    value: false,
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * creates a payment intent from the backend
     */
    StripePayment.prototype.requestPaymentIntent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var name, email, studioId, studioName, selectedTerm, optionalModules, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        name = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.firstname) + ' ' + (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.lastname);
                        email = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.email);
                        studioId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        studioName = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioName);
                        selectedTerm = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.rateBundleTermId);
                        optionalModules = JSON.parse(localStorage.getItem('optionalModules') || '[]');
                        console.log('requesting onetime payment intent for ', name, email);
                        if (!this.missingPaymentDetails) return [3 /*break*/, 1];
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this.fitpayApi.createPaymentIntent(this.config.get, selectedTerm, name, email, studioId, studioName, optionalModules)];
                    case 2:
                        _a.paymentIntent = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Called when the user clicks on a express checkout element (google pay, link, etc)
     * @param event
     * @returns
     */
    StripePayment.prototype.confirmExpressCheckout = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var error, intent, res, res, billingDetails_1, fistLastName, addressParsed, billingDetails, formMappings, allData, recaptchaResponse, isRecaptchaInvalid, testVoucher, customer, fistLastName, _a, _1, street, number, box, formData, formVal, captureRes;
            var _b, _c, _d, _e, _f;
            var _g, _h, _j, _k, _l, _m, _o, _p;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        console.log('payment event', event, this.paymentIntent);
                        // returning from express sets payment switcher to fitBuy
                        (0, payment_switcher_1.setPaymentTab)('PayPal');
                        if (!!this.paymentIntent.onetimePayment) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stripe
                                .confirmSetup({
                                elements: this.stripeElements,
                                confirmParams: {
                                    return_url: window.location.href.split('?')[0], // Use your return URL here
                                },
                                redirect: 'if_required',
                            })
                                .catch(function (e) { return console.error('error confirming setup', e); })];
                    case 1:
                        res = _q.sent();
                        console.log('setup intent res', res);
                        if (res) {
                            error = res.error;
                            intent = res.setupIntent;
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.stripe
                            .confirmPayment({
                            elements: this.stripeElements,
                            confirmParams: {
                                return_url: window.location.href.split('?')[0], // Use your return URL here for paypal, google pay
                            },
                            redirect: 'if_required', // Redirect only if the payment method requires it
                        })
                            .catch(function (e) { return console.error('error confirming payment', e); })];
                    case 3:
                        res = _q.sent();
                        console.log('payment intent res', res);
                        if (res) {
                            error = res.error;
                            intent = res.paymentIntent;
                        }
                        _q.label = 4;
                    case 4:
                        // fill out input fields from express checkout customer data
                        if (((_c = (_b = this.config.get) === null || _b === void 0 ? void 0 : _b.stripe) === null || _c === void 0 ? void 0 : _c.fillFormFieldsUsingExpressCheckout) === true) {
                            billingDetails_1 = event.billingDetails;
                            console.log('billing details', billingDetails_1);
                            fistLastName = this.fitpayApi.nameToFirstNameAndLastName(billingDetails_1.name);
                            addressParsed = this.fitpayApi.addressLineToStreetAndHouseNumber((_d = billingDetails_1.address) === null || _d === void 0 ? void 0 : _d.line1);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.firstname, fistLastName.firstName);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.lastname, fistLastName.lastName);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.city, (_e = billingDetails_1.address) === null || _e === void 0 ? void 0 : _e.city);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.zipCode, (_f = billingDetails_1.address) === null || _f === void 0 ? void 0 : _f.postal_code);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.street, addressParsed.street);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.houseNumber, addressParsed.houseNumber);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.telephone_mobile, billingDetails_1.phone);
                            (0, input_output_helper_const_1._WriteField)(input_mapping_const_1._AllMappings.email, billingDetails_1.email);
                        }
                        if (error) {
                            console.error('payment confirmation error:', error);
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Payment failed'));
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'externalPaymentProviderCallback',
                                value: false,
                            });
                            return [2 /*return*/];
                        }
                        console.log('setup confirmed');
                        (0, generator_const_1._HideErrorMessage)();
                        billingDetails = event.billingDetails;
                        formMappings = lodash_1.default.cloneDeep(input_mapping_const_1._AllMappings);
                        formMappings = (0, input_output_helper_const_1._FilterMappingsBasedOnFields)(formMappings, input_mapping_const_1._BankAccountMapping);
                        console.log('starting validation in container', this.$container);
                        allData = (0, input_output_helper_const_1._ValidateFields)(this.$container, {
                            mappings: formMappings,
                        });
                        recaptchaResponse = document.getElementById('g-recaptcha-response');
                        isRecaptchaInvalid = recaptchaResponse && recaptchaResponse.value.trim() === '';
                        console.log('Captcha invalid?', isRecaptchaInvalid);
                        //Base contract includes modules, startdate, ratebundle etc
                        allData.data.contract = (0, contract_const_1._CreateBaseContract)();
                        (0, fitpay_bank_account_helper_1.setFitPayBankAccountDummy)(this.config, allData);
                        allData.data.studioId = +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        return [4 /*yield*/, (0, voucher_code_const_1._TestVoucherCode)(this.$container)];
                    case 5:
                        testVoucher = _q.sent();
                        if (testVoucher.valid) {
                            allData.data.voucherCode = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.voucherCode);
                        }
                        else {
                            allData.data.voucherCode = '';
                        }
                        customer = allData.data;
                        try {
                            // customer mapping from like google pay, apple pay
                            (_g = customer.customer).city || (_g.city = billingDetails.address.city);
                            (_h = customer.customer).email || (_h.email = billingDetails.email);
                            (_j = customer.customer).telephone_mobile || (_j.telephone_mobile = billingDetails.phone);
                            (_k = customer.customer).zipCode || (_k.zipCode = billingDetails.address.postal_code);
                            customer.customer.paymentChoice = 'DIRECT_DEBIT';
                            customer.contract.notes = (0, notes_helper_const_1.getLocalStorageNotesString)(); // add notes
                            fistLastName = this.fitpayApi.nameToFirstNameAndLastName(billingDetails.name);
                            (_l = customer.customer).firstname || (_l.firstname = fistLastName.firstName);
                            (_m = customer.customer).lastname || (_m.lastname = fistLastName.lastName);
                            _a = billingDetails.address.line1.match(/^(.*?)\s+(\d+(?:[-./]\d+)?)(?:\s*(\S.*))?$/), _1 = _a[0], street = _a[1], number = _a[2], box = _a[3];
                            (_o = customer.customer).street || (_o.street = street);
                            (_p = customer.customer).houseNumber || (_p.houseNumber = number + box);
                        }
                        catch (e) {
                            console.error('failed using customer data from payment provider', e);
                        }
                        allData.data.customer.dateOfBirth = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._BirthdayForm.dateOfBirth);
                        formData = allData.data.customer;
                        formVal = (0, validate_const_1.checkCustomerData)(formData);
                        // make sure customer filled out everything
                        // missing payments dont require any customer data, its already a ML member anyways
                        if ((!this.missingPaymentDetails && (!allData.valid || !formVal)) || isRecaptchaInvalid) {
                            // if not everything is valid, show error
                            console.error('express checkout validation failed: ', allData);
                            this.ongoingPaymentButMissingCustomerDetails = true;
                            this.ongoingPaymentIntent = intent;
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Fill out the form to complete the payment'));
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'expressValidationFailed',
                                value: true,
                            });
                            return [2 /*return*/];
                        }
                        if (!this.missingPaymentDetails) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.fitpayApi.captureMissingPayment(this.config, this.paymentIntent)];
                    case 6:
                        captureRes = _q.sent();
                        console.log('captured ongoing missing payment:', captureRes);
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.fitpayApi.capturePayment(customer, this.config, this.paymentIntent, intent.payment_method)];
                    case 8:
                        captureRes = _q.sent();
                        _q.label = 9;
                    case 9:
                        if (!captureRes.success) {
                            console.error('payment capture error:', captureRes);
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(captureRes.message || 'Payment failed'));
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'externalPaymentProviderCallback',
                                value: false,
                            });
                            this.ongoingPaymentButMissingCustomerDetails = true;
                            this.ongoingPaymentIntent = intent;
                            // hide express checkout, the payment was fine just missing data
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'expressValidationFailed',
                                value: true,
                            });
                            return [2 /*return*/];
                        }
                        // actually should do preview customer first, but since it doesnt do anything useful anyways ...
                        this.communicationService.sendEvent({
                            event: 'custom',
                            module: this,
                            name: 'externalPaymentProviderCallback',
                            value: true,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Called when the member clicks on the webflow "join now" button, not the express checkout
     * Like klarna, card, etc payments
     * @returns
     */
    StripePayment.prototype.startPaymentProcess = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var capture, intent, submitResult, paymentError, paymentMethodId, missingPaymentParams, returnUrl, confirmPayment, res, capture;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // customer already came back from an express payment
                        console.log('ongoing payment?', this.ongoingPaymentButMissingCustomerDetails);
                        if (!this.ongoingPaymentButMissingCustomerDetails) return [3 /*break*/, 5];
                        capture = void 0;
                        intent = {
                            clientSecret: this.ongoingPaymentIntent.client_secret,
                            amount: 0,
                            currency: '',
                            paymentIntentId: this.ongoingPaymentIntent.id,
                            fittecId: (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.fittecId,
                            customerId: '',
                            onetimePayment: !this.ongoingPaymentIntent.id.includes('seti'),
                        };
                        if (!this.missingPaymentDetails) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fitpayApi.captureMissingPayment(this.config, intent)];
                    case 1:
                        capture = _d.sent();
                        console.log('captured ongoing missing payment:', capture);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.fitpayApi.capturePayment(user, this.config, intent, this.ongoingPaymentIntent.payment_method)];
                    case 3:
                        capture = _d.sent();
                        console.log('captured ongoing payment:', capture);
                        _d.label = 4;
                    case 4:
                        if (!capture.success) {
                            console.error('payment capture error:', capture);
                            return [2 /*return*/, { success: false, message: capture.message || 'Payment failed' }];
                        }
                        return [2 /*return*/, { success: true }];
                    case 5: return [4 /*yield*/, this.stripeElements.submit()];
                    case 6:
                        submitResult = _d.sent();
                        if (submitResult.error) {
                            console.error('Error with payment submission:', submitResult.error.message);
                            return [2 /*return*/, { success: false, message: submitResult.error.message }];
                        }
                        missingPaymentParams = this.missingPaymentDetails
                            ? '?' +
                                new URLSearchParams({
                                    email: this.missingPaymentDetails.email,
                                    geburtstag: this.missingPaymentDetails.birthday,
                                }).toString()
                            : '';
                        returnUrl = window.location.href.split('?')[0] + missingPaymentParams;
                        console.log('return url:', returnUrl);
                        if (!this.paymentIntent.onetimePayment) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.stripe.confirmPayment({
                                elements: this.stripeElements,
                                confirmParams: {
                                    return_url: returnUrl,
                                },
                                redirect: 'if_required', // Redirect only if the payment method requires it
                            })];
                    case 7:
                        confirmPayment = _d.sent();
                        paymentError = confirmPayment === null || confirmPayment === void 0 ? void 0 : confirmPayment.error;
                        paymentMethodId = (_b = confirmPayment === null || confirmPayment === void 0 ? void 0 : confirmPayment.paymentIntent) === null || _b === void 0 ? void 0 : _b.payment_method;
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, this.stripe.confirmSetup({
                            elements: this.stripeElements,
                            confirmParams: {
                                return_url: window.location.href.split('?')[0], // Use your return URL here
                            },
                            redirect: 'if_required',
                        })];
                    case 9:
                        res = _d.sent();
                        paymentError = res === null || res === void 0 ? void 0 : res.error;
                        paymentMethodId = (_c = res === null || res === void 0 ? void 0 : res.setupIntent) === null || _c === void 0 ? void 0 : _c.payment_method;
                        _d.label = 10;
                    case 10:
                        if (!paymentError) return [3 /*break*/, 11];
                        console.error('payment error:', paymentError);
                        (0, helper_const_1._ScrollToPageElement)((0, cash_dom_1.default)("[data-ref='".concat(module_mapping_1._MembershipCompletionReferences.fitpayCheckout.uid, "']")));
                        return [2 /*return*/, { success: false, message: (paymentError === null || paymentError === void 0 ? void 0 : paymentError.message) || 'Payment failed' }];
                    case 11:
                        capture = void 0;
                        if (!this.missingPaymentDetails) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.fitpayApi.captureMissingPayment(this.config, this.paymentIntent)];
                    case 12:
                        capture = _d.sent();
                        return [3 /*break*/, 15];
                    case 13: return [4 /*yield*/, this.fitpayApi.capturePayment(user, this.config, this.paymentIntent, paymentMethodId)];
                    case 14:
                        capture = _d.sent();
                        _d.label = 15;
                    case 15:
                        if (!capture.success) {
                            // if the capture fails (e.g. duplicate mail) keep the state as ongoing payment, as you cant submit stripeElements again
                            this.ongoingPaymentButMissingCustomerDetails = true;
                            this.ongoingPaymentIntent = {
                                id: this.paymentIntent.paymentIntentId,
                                client_secret: this.paymentIntent.clientSecret,
                            };
                            this.communicationService.sendEvent({
                                event: 'custom',
                                module: this,
                                name: 'expressValidationFailed',
                                value: true,
                            });
                            return [2 /*return*/, { success: false, message: capture.message }];
                        }
                        console.log('Capured payment:', capture);
                        return [2 /*return*/, { success: true }];
                }
            });
        });
    };
    StripePayment.prototype.checkPaymentIntentStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            // Function to get query parameters from the URL
            function getQueryParam(param) {
                var urlParams = new URLSearchParams(window.location.search);
                return urlParams.get(param);
            }
            var paymentIntentClientSecret, isOnetimePayment;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                paymentIntentClientSecret = getQueryParam('payment_intent_client_secret') || getQueryParam('setup_intent_client_secret');
                isOnetimePayment = ((_a = getQueryParam('payment_intent_client_secret')) === null || _a === void 0 ? void 0 : _a.length) > 0;
                if (paymentIntentClientSecret) {
                    // Check the payment intent status
                    (0, generator_const_1._CreateLoadingScreen)();
                    if (isOnetimePayment) {
                        return [2 /*return*/, this.stripe
                                .retrievePaymentIntent(paymentIntentClientSecret)
                                .then(function (_a) {
                                var paymentIntent = _a.paymentIntent;
                                return _this.handlePaymentIntent(paymentIntent, isOnetimePayment);
                            })
                                .catch(function (error) {
                                console.error('Error retrieving payment intent:', error);
                                return { payment_success: false, post_payment: true, onetime_payment: isOnetimePayment };
                            })];
                    }
                    else {
                        return [2 /*return*/, this.stripe
                                .retrieveSetupIntent(paymentIntentClientSecret)
                                .then(function (_a) {
                                var setupIntent = _a.setupIntent;
                                return _this.handlePaymentIntent(setupIntent, isOnetimePayment);
                            })
                                .catch(function (error) {
                                console.error('Error retrieving payment intent:', error);
                                return { payment_success: false, post_payment: true, onetime_payment: isOnetimePayment };
                            })];
                    }
                }
                else {
                    console.info('No payment intent client secret found in the URL.');
                    return [2 /*return*/, { payment_success: false, post_payment: false, onetime_payment: isOnetimePayment }];
                }
                return [2 /*return*/];
            });
        });
    };
    StripePayment.prototype.handlePaymentIntent = function (paymentIntent, isOnetimePayment) {
        if (paymentIntent) {
            console.log('Payment Intent Status:', paymentIntent.status, paymentIntent);
            // Handle different statuses
            switch (paymentIntent.status) {
                case 'succeeded':
                    console.log('Payment succeeded!');
                    this.ongoingPaymentButMissingCustomerDetails = true;
                    this.ongoingPaymentIntent = paymentIntent;
                    this.communicationService.sendEvent({
                        event: 'custom',
                        module: this,
                        name: 'expressValidationFailed',
                        value: true,
                    });
                    return {
                        payment_success: true,
                        post_payment: true,
                        payment_intent_id: paymentIntent.id,
                        onetime_payment: isOnetimePayment,
                    };
                case 'requires_capture':
                    console.log('Payment needs capture');
                    this.ongoingPaymentButMissingCustomerDetails = true;
                    this.ongoingPaymentIntent = paymentIntent;
                    this.communicationService.sendEvent({
                        event: 'custom',
                        module: this,
                        name: 'expressValidationFailed',
                        value: true,
                    });
                    return {
                        payment_success: true,
                        post_payment: true,
                        payment_intent_id: paymentIntent.id,
                        onetime_payment: isOnetimePayment,
                    };
                case 'requires_payment_method':
                    console.log('Payment failed. Please try again.');
                    return { payment_success: false, post_payment: true, onetime_payment: isOnetimePayment };
                case 'processing':
                    console.log('Payment still processing');
                    return { payment_success: false, post_payment: true, onetime_payment: isOnetimePayment };
                default:
                    console.log('Unhandled payment intent status:', paymentIntent.status);
                    return { payment_success: false, post_payment: true, onetime_payment: isOnetimePayment };
            }
        }
        else {
            console.error('Payment Intent not found.');
            return { payment_success: false, post_payment: true, onetime_payment: isOnetimePayment };
        }
    };
    // if this page is called as callback from an external (klarna for otp, revolut for sub) payment
    StripePayment.prototype.handleReturningPayment = function (returningFromPayment, user) {
        return __awaiter(this, void 0, void 0, function () {
            var studioId, intent, capture, e_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        console.log('Handle returning payment', returningFromPayment);
                        studioId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        intent = {
                            clientSecret: '',
                            amount: 0, // TODO
                            currency: '',
                            paymentIntentId: returningFromPayment.payment_intent_id,
                            customerId: localStorage.getItem(input_mapping_const_1.fitpayMappings.stripeCustomerId.uid),
                            onetimePayment: returningFromPayment.onetime_payment,
                            customer: {
                                stripeAccount: (_c = (_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.stripeStudioMapping) === null || _c === void 0 ? void 0 : _c[studioId],
                                studioId: studioId,
                            },
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, , 7]);
                        capture = void 0;
                        if (!this.missingPaymentDetails) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fitpayApi.captureMissingPayment(this.config, intent)];
                    case 2:
                        capture = _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.fitpayApi.capturePayment(user, this.config, intent, returningFromPayment.payment_intent_id)];
                    case 4:
                        capture = _d.sent();
                        _d.label = 5;
                    case 5:
                        console.log('capture successful', capture);
                        return [2 /*return*/, capture];
                    case 6:
                        e_1 = _d.sent();
                        console.log('capture failed', e_1);
                        return [2 /*return*/, { success: false, message: 'Payment failed' }];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    StripePayment.prototype.readCustomerAndContractFromLocalstorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formMappings, allData, testVoucher, localstorageGuardian;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formMappings = lodash_1.default.cloneDeep(input_mapping_const_1._AllMappings);
                        if (this.magiclinePaymentChoice === 'STRIPE' && this.fitpayEnabled) {
                            //Remove bankaccount as validation since we use stripe
                            formMappings = (0, input_output_helper_const_1._FilterMappingsBasedOnFields)(formMappings, __assign(__assign({}, input_mapping_const_1._BankAccountMapping), { consent: {} }));
                        }
                        allData = { data: (0, input_output_helper_const_1._ReadAllFields)(formMappings) };
                        //Base contract includes modules, startdate, ratebundle etc
                        allData.data.contract = (0, contract_const_1._CreateBaseContract)();
                        //Even tho we might use stripe we always tell ML we use direct debit
                        lodash_1.default.set(allData, 'data.customer.paymentChoice', 'DIRECT_DEBIT');
                        localStorage.setItem('paymentTechnology', this.magiclinePaymentChoice);
                        if (this.magiclinePaymentChoice === 'STRIPE' && this.fitpayEnabled) {
                            //fake data to satisfy Magicline if paid via
                            (0, fitpay_bank_account_helper_1.setFitPayBankAccountDummy)(this.config, allData);
                        }
                        allData.data.studioId = +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        return [4 /*yield*/, (0, voucher_code_const_1._TestVoucherCode)(this.$container)];
                    case 1:
                        testVoucher = _a.sent();
                        if (testVoucher.valid) {
                            allData.data.voucherCode = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.voucherCode);
                        }
                        else {
                            allData.data.voucherCode = '';
                        }
                        allData.data.customer.dateOfBirth = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._BirthdayForm.dateOfBirth);
                        localstorageGuardian = localStorage.getItem('guardianData');
                        if (localstorageGuardian === null || localstorageGuardian === void 0 ? void 0 : localstorageGuardian.length) {
                            allData.data.guardian = JSON.parse(localstorageGuardian);
                        }
                        console.log('ALL DATA', allData);
                        return [2 /*return*/, allData];
                }
            });
        });
    };
    StripePayment.prototype.logToBackend = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)(infrastructure_const_1._CloudFunctions.fitpay + '/log', {
                                headers: { 'Content-Type': 'application/json' },
                                method: 'POST',
                                body: JSON.stringify({ message: message }),
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        console.error('failed sending to backend', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return StripePayment;
}());
exports.StripePayment = StripePayment;
